import { PublicClientApplication } from "@azure/msal-browser";

// MSAL configuration
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_SSO_CLIENT_ID,
    authority:
      "https://login.microsoftonline.com/" +
      process.env.REACT_APP_AZURE_SSO_TENANT_ID,
    redirectUri: window.location.origin + "/auth/callback",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

// Login request configuration
export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);
